(function () {
    'use strict';

    angular
        .module('app')
        .controller('exportMenu', exportMenu);

    exportMenu.$inject = ['$scope', 'loginService', '$filter']; 

    function exportMenu($scope, loginService, $filter) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'exportMenu';
        vm.loginService = loginService;
        $scope.show = false;
        //console.log("Loaded Export Menu");
        vm.toggle = function () {
            $scope.show = !$scope.show;
        }
        vm.loginService = loginService;
        activate();
        vm.menuClicked = function (param) {
            $scope.show = false;
            $scope.onMenuClick(param);
        }

        vm.columnToggle = function (column) {
            var selected = $filter('filter')($scope.exportColumns, { selected: true });
            if (column.selected) {
                if (selected.length > 1) {
                    column.selected = !column.selected;
                }
            }
            else {
                column.selected = !column.selected;
            }
        }

        function activate() { }
    }
})();
